import { render, staticRenderFns } from "./purchaserVisitList.vue?vue&type=template&id=4ca1addb&scoped=true"
import script from "./purchaserVisitList.vue?vue&type=script&lang=js"
export * from "./purchaserVisitList.vue?vue&type=script&lang=js"
import style0 from "./purchaserVisitList.vue?vue&type=style&index=0&id=4ca1addb&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca1addb",
  null
  
)

export default component.exports